export default function BoneoImgFallback() {
  return (
    <div className="mb-6 lg:mb-16 lg:mt-8 max-w-7xl mx-auto px-3 lg:px-4 xxl:px-10 overflow-hidden">
      <div className="bg-grey50 animate-pulse rounded-md h-[585px] md:h-[126px] lg:h-[175px]"></div>
    </div>
  );
}
